import axiosPost from '../axiosPost';

export const conciliacionesGireUpload = async (arg) => {
    const { archivo } = arg

    const body = {
        "service": "GireConciliacionUpload",
        "params": {
            "gireConciliacionArchivoContenido": archivo,
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } 
    catch (err) {
        console.log(err)
    };
};